import Utils from "../utils/utils"
const utilsHelper = new Utils()

export default class MarketingCard{
    constructor(container_id, config, is_debug){
        this.container_id = container_id
        this.config = config
        this.is_debug = is_debug
        this.expected_params = [
            "opt99-marketing-card", 'opt99-tags',
            'opt99_preview_type', 'opt99_preview_token', 
            'opt99_marketing_card_id', 'opt99_target_activity',
            'opt99_target_time', "marketing-card"
        ]
        this.url_param = {
            "old-marketing-card": "marketing-card",
            "marketing-card": "opt99-marketing-card",
            "opt99-tags": "opt99-tags",
        }

        this.target_time = null
    }

    async run(current_url) {
        console.log('current_url', current_url)

        // 存網址的圖卡變數
        this.getParams(current_url, this.expected_params)

        // 判斷是哪家電商
        const platform = utilsHelper.checkPlatform()
        console.log(`platform: ${platform}`)

        let is_activate_card = this.isActivateCard(platform, current_url)
        console.log('is_activate_card: ', is_activate_card)

        // 判斷是否是preview模式
        let preview_token = this.getSpecificParam('opt99_preview_token')
        if (preview_token) {
            let card_id = this.getSpecificParam('opt99_marketing_card_id')
            let target_time = this.getSpecificParam('opt99_target_time')
            this.previewCard(
                platform, current_url, preview_token, card_id, target_time
            )
            return
        }

        // 確認是否有行銷圖卡代碼
        let code = this.getSpecificParam(this.url_param['marketing-card'])
        if (!code) {
            code = this.getSpecificParam(this.url_param['old-marketing-card'])
            if (!code) {
                return
            }
        }

        let user_tags = sessionStorage.getItem('marketing-card-tags')
        let opt99_tags = this.getSpecificParam('opt99-tags')
        if (!user_tags) {
            if (opt99_tags) {
                user_tags = opt99_tags
            }
            else {
                user_tags = '' 
            }
        }

        // 取得行銷圖卡設定檔
        const result = await this.getCard(code, this.container_id, user_tags)
        console.log('result: ', result)

        if (result.cards.length === 0 || is_activate_card === false) {
            return
        }

        // 插入圖卡樣式css
        this.createStyle()

        // 顯示行銷圖卡 
        let device_type = this.detectDeviceWidth()
        let is_param_in_url = false
        if (current_url.indexOf(this.url_param['marketing-card']) !== -1 || current_url.indexOf(this.url_param['old-marketing-card']) !== -1) {
            is_param_in_url = true
        }
        this.displayMarketingCard(result.cards[0], device_type, is_param_in_url, platform)

        // 檢查是否有其他tags，如果大於1代表還有其他同代碼，不同tag的圖卡，所以要啟用區域行銷圖卡功能
        if (result.other_tags.length > 1 && user_tags === '') {
            this.getGeographic(result.other_tags, code, current_url, platform)
        }

        // 判斷是否有自動帶入折扣代碼功能，沒有的話把變數刪除
        console.log('result.cards[0].auto_coupon', result.cards[0].auto_coupon)
        if (result.cards[0].auto_coupon === 0) {
            localStorage.setItem('isActivateCoupon', '0')
        }
        else {
            localStorage.setItem('isActivateCoupon', '1')
        }
    }

    getParams(current_url, expected_params) {
        let url = new URL(current_url)
        let host_name = window.location.hostname;
        let from_url = document.referrer;
        let is_from_other_site = from_url.indexOf(host_name) === -1

        expected_params.forEach(function(expected_param){

            if (url.searchParams.get(expected_param)) {
                localStorage.setItem(expected_param, url.searchParams.get(expected_param))
                sessionStorage.setItem(expected_param, url.searchParams.get(expected_param));
                let s_code_param = sessionStorage.getItem(expected_param)
                console.log(`s_code_param_${expected_param}`,s_code_param)
            }
            // url沒有變數的話判斷sessionStorage
            else {
                let s_code_param = sessionStorage.getItem(expected_param)
                if (is_from_other_site) {
                    if (s_code_param) {
                        localStorage.setItem(expected_param, s_code_param)
                        sessionStorage.removeItem(expected_param)
                    }
                    else {
                        localStorage.removeItem(expected_param)
                    }
                }

            }
        })

    }

    getSpecificParam(name) { 
        return localStorage.getItem(name)
    }

    async getCard(code, container_id, tags){
        let result = []
        try {
            let resp = await utilsHelper.callAPI(
                '', 
                'GET', 
                this.config.API_ENDPOINT + `/view/card?coupon_id=${code}&container_id=${container_id}&tags=${tags}`, 
                null
            ) 
            result = resp.data
        } catch (error) {
            console.log('get_card_error', error)
        }

        return result
    }

    detectDeviceWidth () {
        var now_width = window.screen.width;
        var device = ''
        if (now_width < 768) {
          device = 'mobile';
        }
        else {
          device = 'desktop';
        }
  
        return device;
    }

    async displayMarketingCard(card, device_type, is_param_in_url, platform) {
        console.log('display', card)
        console.log('device_type', device_type)
        let start_at_string = card.start_at.replaceAll('-','/')
        let end_at_string = card.end_at.replaceAll('-','/')
        let campaign_start_at_string = ''
        let campaign_end_at_string = ''
        let type = '1'
        let now = new Date().getTime()

        if (this.target_time) {
            now = this.target_time
        }

        if (card.campaign_start_at) {
            campaign_start_at_string = card.campaign_start_at.replaceAll('-','/')
        }
        
        if (card.campaign_end_at) {
            campaign_end_at_string = card.campaign_end_at.replaceAll('-','/')
        }

        // 如果活動時間有少設定的話，以start_at/end_at為主
        
        if (campaign_start_at_string !== '' && campaign_end_at_string !== '') {
            type = '2'
        }
        
        let start_at = new Date(start_at_string).getTime()
        let end_at = new Date(end_at_string).getTime()
        this.createCard(start_at, end_at, card, 'activity_card_setting', device_type, is_param_in_url, platform)

        // 價格蓋台
        let add_column = ''
        try {
            add_column = JSON.parse(card.add_column)
        } catch (error) {
        }

        if (card.product_mode === 1) {
            if (add_column && add_column.product_mode === 1) {
                console.log('over_price')
                // if (platform === 'cyberbiz') {
                //     await utilsHelper.sleep(2000)
                // }
                this.overPrice(card, add_column, platform)
            }
        }

        // if (type === '1') {
        //     let start_at = new Date(start_at_string).getTime()
        //     let end_at = new Date(end_at_string).getTime()
        //     if (start_at <= now && now <= end_at) {
        //         this.createCard(start_at, end_at, card, 'activity_card_setting', device_type, is_param_in_url, platform)
        //     }
        // }
        // else {
        //     let start_at = new Date(start_at_string).getTime()
        //     let end_at = new Date(end_at_string).getTime()
        //     let campaign_start_at = new Date(campaign_start_at_string).getTime()
        //     let campaign_end_at = new Date(campaign_end_at_string).getTime()
            
        //     if (start_at <= now && now < campaign_start_at) {
        //         this.createCard(start_at, campaign_start_at, card, 'warm_up_setting', device_type, is_param_in_url, platform)
        //     }
        //     else if(campaign_start_at <= now && now < campaign_end_at) {
        //         this.createCard(campaign_start_at,campaign_end_at, card, 'activity_card_setting', device_type, is_param_in_url, platform)
        //     }
        //     else if(campaign_end_at <= now && now < end_at) {
        //         this.createCard(campaign_end_at, end_at, card, 'end_up_setting', device_type, is_param_in_url, platform)
        //     }
            
        // }

    }

    createStyle(){
        let styleElement = document.createElement('style');

        // 設置type屬性為"text/css"
        styleElement.setAttribute('type', 'text/css');

        let cssRules = `
            .dynamic_card_container *{
                border: 0px;
            }
            .dynamic_card_container .time_container * {
                word-wrap: normal !important;
            }
            .mini_dynamic_card_container * {
                border: 0px;
            }
            .reopen_dynamic_card_container *{
                border: 0px;
            }

            .card-text-content > p {
                margin:0px;
            }

            .card-text > .card-header {
                padding: 0px !important;
            }
            .card > .card-footer {
                padding: 0px !important;
            }

            .dynamic_card_container.mobile{
                display:block;
                position:relative;
                z-index:99;
                visibility:visible;
                width:100%;
            }
            .mini_dynamic_card_container.mobile {
                width:100%;
                position:fixed;
                top: 0px;
                z-index: 99;
                text-align:center;
                visibility:hidden;
            }
            .reopen_dynamic_card_container.mobile {
                width:100%;
                position:fixed;
                top:0px;
                z-index: 99;
                visibility:hidden;
            }
            .dynamic_card_container.desktop{
                max-width: 375px;
                width:100%;
                position: fixed;
                z-index: 999;
                right:0px;
                bottom:0px;
                display:block;
                visibility:visible;
            }
            .mini_dynamic_card_container.desktop {
                max-width: 375px;
                width:100%;
                position: fixed;
                z-index: 999;
                left: calc(50% - 187px);
                bottom: 10px;
                display:block;
                visibility:hidden;
                cursor:pointer;
            }

        `;
        if (styleElement.styleSheet) {
            styleElement.styleSheet.cssText = cssRules;
        } 
        else {
            styleElement.appendChild(document.createTextNode(cssRules));
        }

        document.head.appendChild(styleElement);
    }

    createCard(start_at, end_at, card, campaign_type, device_type, is_param_in_url, platform){

        console.log('create_card')
        console.log('start_at',start_at)
        console.log('end_at', end_at)
        console.log('card', card)
        console.log('campaign_type', campaign_type)
        console.log('device_type',device_type)
        console.log(`platform: ${platform}`)
        let dynamic_card_container = ''
        let mini_dynamic_card_container = '';
        let reopen_dynamic_card_container = '';
        let add_column = ''
        try {
            add_column = JSON.parse(card.add_column)
        } catch (error) {
            console.log('mk_add_error', add_column)
        }
        let uuid = 'k-' + utilsHelper.getUUID()
        console.log('mk_add_column', add_column)
        let target_setting = card
        if (add_column && add_column[campaign_type]) {
            target_setting = add_column[campaign_type]
        }
        console.log('target_setting',target_setting)
        let setting_add_column = ''
        try {
            setting_add_column = JSON.parse(target_setting.add_column)
        } catch (error) {
            console.log('mk_add_error_2', target_setting)
        }
        let insert_ele = document.getElementsByTagName('body')[0];
        switch (device_type) {
            case 'mobile':
                dynamic_card_container = `
                    <div class="dynamic_card_container mobile ${uuid}"
                        style="
                            margin:${card.mobile_card_margin};
                        "
                    >
                    </div>
                `
                mini_dynamic_card_container = `
                    <div class="mini_dynamic_card_container mobile ${uuid}"
                        style="
                            padding:${card.mobile_card_padding};
                            margin:${card.mobile_mini_card_margin};
                        "
                    >
                    </div>
                `
                reopen_dynamic_card_container = `
                    <div class="reopen_dynamic_card_container mobile ${uuid}"
                        style="
                            margin:${card.mobile_mini_card_margin};
                        "
                    >
                    </div>
                `

                break;
            case 'desktop':
                dynamic_card_container = `
                    <div class="dynamic_card_container desktop ${uuid}"
                        style="
                            margin: ${card.desktop_card_margin};
                        "
                    >
                    </div>
                `
                mini_dynamic_card_container = `
                    <div class="mini_dynamic_card_container desktop ${uuid}"
                    >
                    </div>
                `

                break;
        }

        dynamic_card_container = utilsHelper.createDomByHtmlString(dynamic_card_container);
        dynamic_card_container.innerHTML = target_setting.card_content;
        console.log('dynamic_card_container', dynamic_card_container)

        mini_dynamic_card_container = utilsHelper.createDomByHtmlString(mini_dynamic_card_container);
        if (device_type === 'desktop') {
            mini_dynamic_card_container.innerHTML = target_setting.desktop_card_hint
        }
        else {
            mini_dynamic_card_container.innerHTML = target_setting.card_hint;
        }
        
        console.log('mini_dynamic_card_container', mini_dynamic_card_container)

        if (reopen_dynamic_card_container) {
            reopen_dynamic_card_container = utilsHelper.createDomByHtmlString(reopen_dynamic_card_container)
            reopen_dynamic_card_container.innerHTML = target_setting.card_content;
        }
        console.log('reopen_dynamic_card_container', reopen_dynamic_card_container)
        let timer_1 = {}
        let timer_2 = {}
        let timer_3 = {}
        if (target_setting.is_countdown === true) {
            this.initCountDownTimer(end_at, timer_1, dynamic_card_container, 'init', target_setting.repeat_day, campaign_type, setting_add_column.timer_off_text, setting_add_column.timer_off_text_color)
            this.initCountDownTimer(end_at, timer_2, mini_dynamic_card_container, 'init', target_setting.repeat_day, campaign_type, setting_add_column.timer_off_text, setting_add_column.timer_off_text_color)
            if(reopen_dynamic_card_container && device_type === 'mobile'){
              this.initCountDownTimer(end_at, timer_3, reopen_dynamic_card_container, 'init', target_setting.repeat_day, campaign_type, setting_add_column.timer_off_text, setting_add_column.timer_off_text_color)
            }
        }
        
        insert_ele.insertAdjacentHTML('afterbegin', dynamic_card_container.outerHTML);
        insert_ele.insertAdjacentHTML('afterbegin', mini_dynamic_card_container.outerHTML);
        if (reopen_dynamic_card_container) {
            insert_ele.insertAdjacentHTML('afterbegin', reopen_dynamic_card_container.outerHTML);
        } 

        if (target_setting.is_countdown === true) {
            timer_1 = {}
            timer_2 = {}
            let dynamic_card_container_ele = document.querySelector(`.dynamic_card_container.${uuid}`)
            let mini_card_container_ele = document.querySelector(`.mini_dynamic_card_container.${uuid}`)
            this.initCountDownTimer(end_at, timer_1, dynamic_card_container_ele, 'cron', target_setting.repeat_day, campaign_type, setting_add_column.timer_off_text, setting_add_column.timer_off_text_color)
            this.initCountDownTimer(end_at, timer_2, mini_card_container_ele, 'cron', target_setting.repeat_day, campaign_type, setting_add_column.timer_off_text, setting_add_column.timer_off_text_color)
            let timer_ele = dynamic_card_container_ele.querySelector('.count-down-timer')
            let timer_ele_2 = mini_card_container_ele.querySelector('.count-down-timer')
            timer_ele.style.display = 'block'
            timer_ele_2.style.display = 'block'
            if(reopen_dynamic_card_container && device_type === 'mobile'){
                timer_3 = {}
                let reopen_dynamic_card_container_ele = document.querySelector(`.reopen_dynamic_card_container.${uuid}`)
                this.initCountDownTimer(end_at, timer_3, reopen_dynamic_card_container_ele, 'cron', target_setting.repeat_day, campaign_type, setting_add_column.timer_off_text, setting_add_column.timer_off_text_color)
                let timer_ele_3 = reopen_dynamic_card_container_ele.querySelector('.count-down-timer')
                timer_ele_3.style.display = 'block'
            }
        }
        else {
            let dynamic_card_container_ele = document.querySelector(`.dynamic_card_container.${uuid}`)
            let mini_card_container_ele = document.querySelector(`.mini_dynamic_card_container.${uuid}`)
            let timer_ele = dynamic_card_container_ele.querySelector('.count-down-timer')
            let timer_ele_2 = mini_card_container_ele.querySelector('.count-down-timer')
            if (timer_ele) {
                timer_ele.style.display = 'none'
            }
            if (timer_ele_2) {
                timer_ele_2.style.display = 'none'
            }
            
            
            if(reopen_dynamic_card_container && device_type === 'mobile'){
                timer_3 = {}
                let reopen_dynamic_card_container_ele = document.querySelector(`.reopen_dynamic_card_container.${uuid}`)
                let timer_ele_3 = reopen_dynamic_card_container_ele.querySelector('.count-down-timer')
                if (timer_ele_3) {
                    timer_ele_3.style.display = 'none'
                }
                
            }
        }
        

        // 如果網址沒有帶行銷圖卡參數的話，預設先顯示迷你圖卡
        console.log('is_param_in_url', is_param_in_url)
        if (!is_param_in_url) {
            let dynamic_card_container_ele = document.querySelector('.dynamic_card_container')
            let mini_card_container_ele = document.querySelector('.mini_dynamic_card_container')
            dynamic_card_container_ele.style.visibility = 'hidden';
            mini_card_container_ele.style.visibility = 'visible';
            dynamic_card_container_ele.style.display = 'none';
        }

        // 關閉圖卡事件
        let close_card_btn = document.querySelector(`.dynamic_card_container.${uuid} i[name="close_card_btn"]`)
        let reopen_close_card_btn = document.querySelector(`.reopen_dynamic_card_container.${uuid} i[name="close_card_btn"]`)
        let mini_card_container_ele_out = null
        let callback = null
        console.log('close_card_btn', close_card_btn)
        console.log('reopen_close_card_btn', reopen_close_card_btn)
        switch (device_type) {
            case 'mobile':
                callback = function(entries, observer){
                    let dynamic_card_container_ele = document.querySelector(`.dynamic_card_container.${uuid}`)
                    let mini_card_container_ele = document.querySelector(`.mini_dynamic_card_container.${uuid}`)
                    let reopen_dynamic_card_container_ele = document.querySelector(`.reopen_dynamic_card_container.${uuid}`)

                    if(entries[0].isIntersecting === true){
                        dynamic_card_container_ele.style.visibility = 'visible';
                        dynamic_card_container_ele.style.display = 'block'
                        mini_card_container_ele.style.visibility = 'hidden';
                        reopen_dynamic_card_container_ele.style.visibility = 'hidden';
                    }
                    else {
                        dynamic_card_container_ele.style.visibility = 'hidden';
                        if(window.getComputedStyle(reopen_dynamic_card_container_ele).getPropertyValue("visibility") === 'hidden'){
                            mini_card_container_ele.style.visibility = 'visible';
                        }
                    }

                    mini_card_container_ele_out = document.querySelector(`.mini_dynamic_card_container.${uuid}`)
                    mini_card_container_ele_out.onclick = function(){
                        dynamic_card_container_ele.style.display = 'block'
                        dynamic_card_container_ele.style.visibility = 'visible';
                        mini_card_container_ele.style.visibility = 'hidden';
                        if (entries[0].isIntersecting !== true) {
                            reopen_dynamic_card_container_ele.style.visibility = 'visible';
                        }
                    }
                }
                var observer = new IntersectionObserver(callback, null);
                var target;
                target = document.querySelector(`.dynamic_card_container.${uuid}`);
                observer.observe(target);
                close_card_btn.onclick = function(){
                    let dynamic_card_container_ele = document.querySelector(`.dynamic_card_container.${uuid}`)
                    let mini_card_container_ele = document.querySelector(`.mini_dynamic_card_container.${uuid}`)
                    dynamic_card_container_ele.style.display = 'none'
                    dynamic_card_container_ele.style.visibility = 'hidden';
                    mini_card_container_ele.style.visibility = 'visible';
                }
                reopen_close_card_btn.onclick = function(){
                    let mini_card_container_ele = document.querySelector(`.mini_dynamic_card_container.${uuid}`)
                    let reopen_dynamic_card_container_ele = document.querySelector(`.reopen_dynamic_card_container.${uuid}`)
                    reopen_dynamic_card_container_ele.style.visibility = 'hidden';
                    mini_card_container_ele.style.visibility = 'visible';
                }
                break;
            case 'desktop':
                close_card_btn.onclick = function(){
                    let dynamic_card_container_ele = document.querySelector(`.dynamic_card_container.${uuid}`)
                    let mini_card_container_ele = document.querySelector(`.mini_dynamic_card_container.${uuid}`)
                    dynamic_card_container_ele.style.display = 'none'
                    dynamic_card_container_ele.style.visibility = 'hidden';
                    mini_card_container_ele.style.visibility = 'visible';
                }
                mini_card_container_ele_out = document.querySelector(`.mini_dynamic_card_container.${uuid}`)
                mini_card_container_ele_out.onclick = function(){
                    let dynamic_card_container_ele = document.querySelector(`.dynamic_card_container.${uuid}`)
                    let mini_card_container_ele = document.querySelector(`.mini_dynamic_card_container.${uuid}`)
                    dynamic_card_container_ele.style.display = 'block'
                    dynamic_card_container_ele.style.visibility = 'visible';
                    mini_card_container_ele.style.visibility = 'hidden';
                }
                
        }

        // 最後根據電商版型微調一些樣式
        // .getPropertyValue('margin-top')
        console.log(`微調${platform}`)
        if (platform === 'cyberbiz') {
            if (device_type === 'desktop') {
                // 右下角有官網的小泡泡
                let dynamic_card_container_ele = document.querySelector(`.dynamic_card_container.${uuid}`)
                dynamic_card_container_ele.style.right = '60px'
            }
        }
        else if(platform === '91app') {
            if (device_type === 'desktop') {
                // 右下角有官網的小泡泡
                let dynamic_card_container_ele = document.querySelector(`.dynamic_card_container.${uuid}`)
                dynamic_card_container_ele.style.right = '80px'
            }
        }

    }

    isActivateCard(platform, current_url){
        let url = new URL(current_url)
        let pathname = url.pathname
        let result = false
        switch (platform) {
            case 'shopline':
                if (pathname.indexOf('cart') === -1 && pathname.indexOf('checkout') === -1 && pathname.indexOf('orders') === -1) {
                    result = true
                }
                break;
            case 'cyberbiz':
                if (pathname.indexOf('carts') === -1 && pathname.indexOf('/orders') === -1) {
                    result = true
                }
                break;
            case '91app':
                if (pathname.indexOf('ShoppingCart') === -1 && pathname.indexOf('/Pay/Finish') === -1) {
                    result = true
                }
                break;
            default:
                result = true
        }

        return result
    }

    initCountDownTimer(end_at, timer, timer_container, type, repeat_day, campaign_type, timeoff_text, timeoff_color){

        if (campaign_type === 'end_up_setting') {
            console.log('end_up_settingend_up_settingend_up_settingend_up_setting')
            timer_container.getElementsByClassName("t_description")[0].innerText = timeoff_text
            timer_container.getElementsByClassName("t_description")[0].style.color = timeoff_color
            timer_container.getElementsByClassName("t_description_end")[0].style.display = 'none'
            timer_container.getElementsByClassName("t_days")[0].style.display = 'none'
            timer_container.getElementsByClassName("t_days_unit")[0].style.display = 'none'
            timer_container.getElementsByClassName("t_hours")[0].style.display = 'none'
            timer_container.getElementsByClassName("t_hours_unit")[0].style.display = 'none'
            timer_container.getElementsByClassName("t_minutes")[0].style.display = 'none'
            timer_container.getElementsByClassName("t_minutes_unit")[0].style.display = 'none'
            timer_container.getElementsByClassName("t_seconds")[0].style.display = 'none'
            timer_container.getElementsByClassName("t_seconds_unit")[0].style.display = 'none'

          }

        let that = this
        switch (type) {
  
            case 'init':
              console.log('init')
              var now = new Date().getTime();
            
              if (this.target_time) {
                now = this.target_time
              }

              var distance = end_at - now;
              if (distance < 0) {
                if (repeat_day !== 0 && repeat_day !== '' && !isNaN(repeat_day)) {
                    var repeat_day_second = repeat_day *  24 * 60 * 60 * 1000
                    console.log('重複時間',repeat_day_second)
                    var lost_duration = 0
                    if (new Date().getTime() - end_at < repeat_day_second) {
                      console.log('進1')
                      lost_duration = repeat_day_second - (new Date().getTime() - end_at)  
                    }
                    else {
                      console.log('進2')
                      lost_duration = repeat_day_second - (new Date().getTime() - end_at )% repeat_day_second
                    }
            
                    distance = lost_duration
                  }
              }

              
              if (distance < 0){
                //if (timer_container !== null) {
                  timer_container.getElementsByClassName("t_days")[0].innerText = '00'
                  timer_container.getElementsByClassName("t_hours")[0].innerText = '00'
                  timer_container.getElementsByClassName("t_minutes")[0].innerText = '00'						
                  timer_container.getElementsByClassName("t_seconds")[0].innerText = '00'	
                //}
                        
                return
              }
              var show_units = this.getCountDownUnit(distance)
              //console.log(show_units)
              //if (show_units !== null) {
                var units = Object.keys(show_units)
                //if (units !== null) {
                  units.forEach(function(unit){
                    if (timer_container !== null) {
                      timer_container.getElementsByClassName(unit)[0].innerText = show_units[unit]
                    }
                    
                  })
                //}
              //} 
              
                    
              break;
              
            case 'cron':
              console.log('cron')
              timer = setInterval(function() {
                var now = new Date().getTime();
                if (that.target_time) {
                    now = that.target_time
                }
                var distance = end_at - now;
                if (distance < 0) {
                    if (repeat_day !== 0 && repeat_day !== '' && !isNaN(repeat_day)) {
                        var repeat_day_second = repeat_day *  24 * 60 * 60 * 1000
                        console.log('重複時間',repeat_day_second)
                        var lost_duration = 0
                        if (new Date().getTime() - end_at < repeat_day_second) {
                            console.log('進1')
                            lost_duration = repeat_day_second - (new Date().getTime() - end_at)  
                        }
                        else {
                            console.log('進2')
                            lost_duration = repeat_day_second - (new Date().getTime() - end_at )% repeat_day_second
                        }
                
                        distance = lost_duration
                    }
                }


                if (campaign_type === 'end_up_setting') {
                    clearInterval(timer);
                }
                
                if (distance < 0){
                  clearInterval(timer);
                  //if (timer_container !== null) {
                    timer_container.getElementsByClassName("t_days")[0].innerText = '00'
                    timer_container.getElementsByClassName("t_hours")[0].innerText = '00'
                    timer_container.getElementsByClassName("t_minutes")[0].innerText = '00'						
                    timer_container.getElementsByClassName("t_seconds")[0].innerText = '00'
                  //}
                              
                  return
                }
            
                var show_units = that.getCountDownUnit(distance)
                //console.log(show_units)
                //if (show_units !== null) {
                  var units = Object.keys(show_units)
                  //console.log(units)
                  //if (units !== null) {
                    units.forEach(function(unit){
                      //console.log('765行',unit)
                      if (timer_container !== undefined) {
                        //console.log('qqqqqq')
                        timer_container.getElementsByClassName(unit)[0].innerText = show_units[unit]
                      }
                    
                    })
                  //}
                //}
                
              },1000);
              
              break;
          }
    }

    getCountDownUnit(distance) {
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        days = days.toString()
        if (days.length === 1) {
          days = '0' + days
        }
        hours = hours.toString()
        if (hours.length === 1) {
          hours = '0' + hours
        }				
        minutes = minutes.toString()
        if (minutes.length === 1) {
          minutes = '0' + minutes
        }	
        seconds = seconds.toString()
        if (seconds.length === 1) {
          seconds = '0' + seconds
        }	
      
        var result = {
          t_days: days,
          t_hours: hours,
          t_minutes: minutes,
          t_seconds: seconds
        }
        return result
    }

    getGeographic(other_tags, code, current_url, platform){
        // console.log('取得地理位置')
        let that = this
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                function(position){
                    that.getGeographicSuccess(position, other_tags, code, current_url, platform)
                },
                function(error){
                    that.getGeographicFail(error)
                } 
            );
    
        }
    }

    async getGeographicSuccess(position, other_tags, code, current_url, platform){
        console.log('position: ',position);
        var lng = position.coords.longitude
        var lat = position.coords.latitude
        // sessionStorage.setItem('userLocaiton', userLocation);
        // reverseGeoCode(lng,lat);
        let location_info = await this.getUserAreaByLoaction(lng, lat)
        let user_location = location_info.address.suburb + ',' + location_info.address.city
        console.log('user_location:',user_location)
        let match_tag = other_tags.find(function(other_tag){
            return user_location === other_tag 
        })

        console.log('match_tag_1:', match_tag)

        if (!match_tag) {
            match_tag = other_tags.find(function(other_tag){
                let tmp_tag = other_tag.replace('全區', '')
                console.log('tmp_tag:',tmp_tag)
                return user_location.includes(tmp_tag) && tmp_tag
            })
        }

        console.log('match_tag_2:', match_tag)

        if (!match_tag) {
            return
        }

        sessionStorage.setItem('marketing-card-tags', match_tag)
        // 取得行銷圖卡設定檔
        const result = await this.getCard(code, this.container_id, match_tag)
        console.log('result: ', result)

        if (result.cards.length === 0) {
            return
        }

        // 插入圖卡樣式css
        this.createStyle()

        
        let device_type = this.detectDeviceWidth()
        let is_param_in_url = false
        if (current_url.indexOf(this.url_param['marketing-card']) !== -1) {
            is_param_in_url = true
        }


        // 先移除現有的行銷圖卡
        let dynamic_card_container = document.querySelector('.dynamic_card_container')
        let mini_dynamic_card_container = document.querySelector('.mini_dynamic_card_container')
        let reopen_dynamic_card_container = document.querySelector('.reopen_dynamic_card_container')
        if (dynamic_card_container) {
            dynamic_card_container.remove()
        }
        if (mini_dynamic_card_container) {
            mini_dynamic_card_container.remove()
        }
        if (reopen_dynamic_card_container) {
            reopen_dynamic_card_container.remove()
        }

        // 顯示行銷圖卡 
        this.displayMarketingCard(result.cards[0], device_type, is_param_in_url, platform)

    }

    getGeographicFail(error){
        console.log('error', error)
    }

    async getUserAreaByLoaction(lng,lat){
        //console.log('開始反查位置！')
        let api = "https://nominatim.openstreetmap.org/reverse?format=json&lat="+ lat + "&lon=" + lng + "&zoom=18&addressdetails=1"
        let result = await utilsHelper.callAPI(
            '','GET', api, null
        )
        // console.log('area_result:', result)

        return result
    }

    async previewCard(platform, current_url, preview_token, card_id, target_time){

        // 取得圖卡
        let result = null
        try {
            let resp = await utilsHelper.callAPI(
                '', 
                'GET', 
                this.config.API_ENDPOINT + `/view/card/preview?id=${card_id}&token=${preview_token}`, 
                null
            ) 
            console.log('preivew_card', resp)
            result = resp.data
        } catch (error) {
            console.log('get_card_error', error)
        }

        if (!result) {
            return
        }

        this.createStyle()

        try {
            let tmp_target_time = new Date(target_time)
        } catch (error) {
            target_time = new Date().toISOString()
        }

        this.target_time = new Date(target_time).getTime()
        
        let that = this
        setInterval(function(){
            that.target_time += 1000
        }, 1000)

        let device_type = this.detectDeviceWidth()
        let is_param_in_url = false
        if (current_url.indexOf('opt99_marketing_card_id') !== -1) {
            is_param_in_url = true
        }
        this.displayMarketingCard(
            result, device_type, is_param_in_url, platform
        )

    }
    // 這個功能只能在無品項選擇的商品用
    // 有品項的蓋了之後，如果點來點去品項會被改回原本的價格
    overPrice(card, add_column, platform){
        let container = this.getProductContainer(platform)
        
        if (!container) {
            console.log('no_container')
            return
        }
        let preview_url = card.preview_url
        if (!decodeURIComponent(window.location.href).includes(preview_url)) {
            console.log('no_url')
            return
        }
        console.log('do_price', add_column)
        if (platform === 'cyberbiz') {
            let price_title = container.querySelector('span.title')
            let price_text = container.querySelector('span.price')

            if (price_title) {
                price_title.setAttribute('over_price','true')
                price_title.classList.add('over_price')
                price_title.style.setProperty('color', add_column['product_text_color'], 'important')
                price_title.style.setProperty('font-size', add_column['product_text_size'], 'important')
                price_title.innerText = add_column['product_text']

            }
            if (price_text) {
                price_text.setAttribute('over_price','true')
                price_text.classList.add('over_price')
                price_text.style.setProperty('color', add_column['discount_price_color'], 'important')
                price_text.style.setProperty('font-size', add_column['discount_price_size'], 'important')
                price_text.innerText = add_column['discount_price']
            }
            
            this.listenPriceChange(add_column)

        }
        else if(platform === 'shopline') {
            let result = this.getProductPriceContainer(platform, container)
            let price_container = result.price_container
            let is_sales = result.is_sales
            console.log('shopline_price',price_container)
            console.log('is_sales', is_sales)
            if (price_container) {
                let price_title_html = `<div style="
                        color: ${add_column['product_text_color']};
                        font-size: ${add_column['product_text_size']};
                    "
                >
                    ${add_column['product_text']}
                </div>`
                let price_title_ele = utilsHelper.createDomByHtmlString(price_title_html)

                            
                if (is_sales) {
                    console.log('sales!')
                    let price_text = price_container.closest('.price')
                    if (!price_text) {
                        price_text = price_container.querySelector('.price')
                    }
                    console.log('price_text1',price_text)
                    if (price_text) {
                        price_text.style.setProperty('color', add_column['discount_price_color'], 'important')
                        price_text.style.setProperty('font-size', add_column['discount_price_size'], 'important')
                        console.log('price_text2',add_column['discount_price'])
                        price_text.innerText = add_column['discount_price']
                    }
                    price_container.insertAdjacentElement('afterbegin',price_title_ele)
                }
                else {
                    console.log('not_sales!')
                    let price_text = price_container.closest('.price')
                    if (!price_text) {
                        price_text = price_container.querySelector('.price')
                    }
                    if (price_text) {
                        price_text.classList.add('price-crossed')
                    }

                    let new_price_text_html = `<div style="
                        color: ${add_column['discount_price_color']};
                        font-size: ${add_column['discount_price_size']};
                        "
                    >
                        ${add_column['discount_price']}
                    </div>`
                    let new_price_text = utilsHelper.createDomByHtmlString(new_price_text_html)
                    if (new_price_text) {
                        price_container.insertAdjacentElement('afterend', new_price_text)
                    }
                    price_container.insertAdjacentElement('afterend',price_title_ele)
                    
                }
            }

        }
        else if (platform === '91app') {
            let result = this.getProductPriceContainer(platform, container)
            let price_container = result.price_container
            let is_sales = result.is_sales
            console.log('shopline_price',price_container)
            console.log('is_sales', is_sales)
            if (price_container) {
                let price_title_html = `<div style="
                        color: ${add_column['product_text_color']};
                        font-size: ${add_column['product_text_size']};
                    "
                >
                    ${add_column['product_text']}
                </div>`
                let price_title_ele = utilsHelper.createDomByHtmlString(price_title_html)
                let mobile_price_title_ele = utilsHelper.createDomByHtmlString(price_title_html)
                            
                if (is_sales) {
                    // 原頁面
                    console.log('sales!')
                    let price_text = price_container.querySelector('.salepage-price')
                    console.log('price_text1',price_text)
                    if (price_text) {
                        price_text.style.setProperty('color', add_column['discount_price_color'], 'important')
                        price_text.style.setProperty('font-size', add_column['discount_price_size'], 'important')
                        console.log('price_text2',add_column['discount_price'])
                        price_text.innerText = add_column['discount_price']
                    }
                    let suggestprice_ele = price_container.querySelector('.salepage-suggestprice')
                    suggestprice_ele.insertAdjacentElement('afterend', price_title_ele)

                    // 手機加入購物車popup
                    let mobile_product_container = document.querySelector('.product-detail')
                    if (mobile_product_container) {
                        let mobile_price_text = mobile_product_container.querySelector('.product-price')
                        if (mobile_price_text) {
                            // 重新設定樣式
                            mobile_price_text.style.setProperty('display', 'flex', 'important')
                            mobile_price_text.style.setProperty('flex-direction', 'column', 'important')
                            // mobile_price_text.style.setProperty('padding-left', '12px', 'important')
                            mobile_price_text.style.setProperty('float', 'unset', 'important')
                            mobile_price_text.style.setProperty('height', 'auto', 'important')
                            mobile_price_text.style.setProperty('line-height', '1', 'important')
                            
                            let price_info = mobile_product_container.querySelector('.price-wrapper')
                            if (price_info) {
                                price_info.style.setProperty('position', 'unset', 'important')
                            }
                            
                            mobile_price_text.style.setProperty('color', add_column['discount_price_color'], 'important')
                            mobile_price_text.style.setProperty('font-size', add_column['discount_price_size'], 'important')
                            console.log('price_text2',add_column['discount_price'])
                            mobile_price_text.innerText = add_column['discount_price']
                            mobile_price_text.insertAdjacentElement('beforebegin', mobile_price_title_ele)
                        }
                    }
                }
                else {
                    console.log('not_sales!')
                    // 取原本的價格建立建議售價
                    let price_text = price_container.querySelector('.salepage-price-container')
                    if (price_text) {
                        // 建議售價(畫線)
                        let original_price_text = price_text.innerText
                        let original_price_html = `
                            <div class="salepage-suggestprice">${original_price_text}</div>
                        `
                        let original_price_ele = utilsHelper.createDomByHtmlString(original_price_html)
                        
                        // 原價改成折扣價
                        price_text.style.setProperty('color', add_column['discount_price_color'], 'important')
                        price_text.style.setProperty('font-size', add_column['discount_price_size'], 'important')
                        price_text.innerText = add_column['discount_price']
                        
                        // 插入title再插入建議售價
                        price_container.insertAdjacentElement('afterbegin', price_title_ele)
                        price_container.insertAdjacentElement('afterbegin', original_price_ele)
                        
                    }

                    
                }
            }
        }
       
    }

    getProductContainer(platform){
        let container_querys = []
        let container = null
        if (platform === 'cyberbiz') {
            container_querys = [
                '.product_content'
            ]
        }
        else if (platform === 'shopline') {
            container_querys = [
                '.ProductDetail-product[sl-component="product-info"]',
                '.product-info.row:not(.ng-hide)',
                '.ProductDetail-product-info.js-product-info'
            ]
        }
        else if(platform === '91app') {
            container_querys = [
                '.salepage-container'
            ]
        }

        for (let idx = 0; idx < container_querys.length; idx++) {
            let query = container_querys[idx]
            if (document.querySelector(query)) {
                container = document.querySelector(query)
                break
            }
        }
        return container
    }

    getProductPriceContainer(platform, product_container){
        let container_querys = []
        let price_container = null
        let is_sales = false
        if (platform === 'cyberbiz') {
        }
        else if (platform === 'shopline') {
            console.log('shopline')
            container_querys = [
                '.price-sale.js-price',
                '.price.js-price',
                '.price-regular.js-price'
            ]
            for (let idx = 0; idx < container_querys.length; idx++) {
                let query = container_querys[idx]
                
                if (product_container.querySelector(query)) {
                    price_container = product_container.querySelector(query)
                    if (query.includes('sale')) {
                        is_sales = true
                    }
                    break
                }
            }
        }
        else if(platform === '91app') {
            container_querys = [
                '.price-block'
            ]
            for (let idx = 0; idx < container_querys.length; idx++) {
                let query = container_querys[idx]
                if (product_container.querySelector(query)) {
                    price_container = product_container.querySelector(query)
                    let suggest = product_container.querySelector('.salepage-suggestprice')
                    if (suggest) {
                        is_sales = true
                    }
                    break
                }
            }
        }

        console.log('price_container', price_container)
        return { price_container, is_sales}
    }

    listenPriceChange(add_column){
        var listen_ele = document.querySelector('body')


        console.log('listen_ele',listen_ele)
        
        function observeProductVariant(listen_ele) {
          
          var callback = function(mutations) {
          
        
            mutations.forEach(function(mutation){
        
                if (mutation.type === 'childList') {
                    let price_title = document.querySelector('span.title')
                    let price_text = document.querySelector('span.price')
                    
                    if (price_title && price_title.innerText !== add_column['product_text'] ) {
                        price_title.setAttribute('over_price','true')
                        price_title.classList.add('over_price')
                        price_title.style.setProperty('color', add_column['product_text_color'], 'important')
                        price_title.style.setProperty('font-size', add_column['product_text_size'], 'important')
                        price_title.innerText = add_column['product_text']
                    }
                    
                    if (price_text && price_text.innerText !==  add_column['discount_price']) {
                        price_text.setAttribute('over_price','true')
                        price_text.classList.add('over_price')
                        price_text.style.setProperty('color', add_column['discount_price_color'], 'important')
                        price_text.style.setProperty('font-size', add_column['discount_price_size'], 'important')
                        price_text.innerText = add_column['discount_price']
                    }
                    
                }
            })
        
          }  
                
          var observer = new MutationObserver(callback)
          
          // configuration of the observer:
          var config = { subtree: true, attributes: true, childList: true, characterData: true };
        
          // pass in the target node, as well as the observer options
          observer.observe(listen_ele, config);
          
        }
        
        observeProductVariant(listen_ele)
    }

}